import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.currencies.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.currencies.actionsLoading;
export const getItems = (state:RootState) => state.currencies.items;
export const getItemsSelect = (state:RootState) => state.currencies.dropDownItems;
export const getItemsCount = (state:RootState) => state.currencies.itemsCount;
export const getItemForEdit = (state:RootState) => state.currencies.itemForEdit;
export const getError = (state:RootState) => state.currencies.error;
export const getErrorAction = (state:RootState) => state.currencies.errorAction;
export const validationErrors = (state: RootState) => state.currencies.validationErrors;
export const getFilters = (state: RootState) => state.currencies.filters;
